import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

import { Constants } from '../../helper/constants';
import { Global } from '../../../../app.global';
import { AdminService } from '../../../../layouts/services/admin.service';
import { ReportsService } from '../../services/reports.service';
import { TeamStatsModel } from '../../viewmodels/team-stats.model';
import { SettingsService } from '../../../../authentication/services/settings.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  public constants = Constants;
  currentTimeDate = moment().utc().format('ddd DD MMM');
  alerts = [];
  noticeBoardItems = [];
  selectedAlert: any;
  selectedNotice: any;
  councilLogo = '';
  teamStats = new TeamStatsModel();

  constructor(
    private modalService: NgbModal,
    private adminService: AdminService,
    private global: Global,
    private reportsServ: ReportsService,
    private settingsService: SettingsService
  ) {}

  ngOnInit() {
    this.setTeamStats();
    // this.councilLogo = this.global.appSettings['Council.Logo'] ?
    // this.global.appSettings['Council.Logo'] : `${this.constants.assetsPath}/img/barbour-logic-logo.png`;
    // this.councilLogo = `${this.constants.assetsPath}/img/barbour-logic-logo.png`;
    this.settingsService.getApplicationSetting('Council.Logo').subscribe(
      (result) => {
        this.councilLogo = result;
      },
      (err) => {
        this.councilLogo = `${this.constants.assetsPath}/img/barbour-logic-logo.png`;
      }
    );
    this.setAlerts();
    this.setNoticeBoardItems();
  }

  setTeamStats() {
    this.reportsServ.getTeamStats().subscribe(
      (teamStats) => {
        this.teamStats = teamStats;
      },
      (err) => console.log(err)
    );
  }

  // openModal(content, alert) {
  //   this.selectedAlert = alert;
  //   this.modalService.open(content, { centered: true });
  // }

  openModal(content, notice) {
    this.selectedNotice = notice;
    this.modalService.open(content, { centered: true });
  }

  setAlerts() {
    this.alerts = [];
    this.adminService.getAllAlerts(0, false, 99).subscribe((result) => {
      if (result) {
        result.reverse().forEach((alert) => {
          if (this.alerts.length === 3) {
            return false;
          }

          if (alert.action === 0) {
            this.alerts.push(alert);
          }
        });
      }
    });
  }

  setNoticeBoardItems() {
    this.noticeBoardItems = [];
    this.adminService.getNoticeBoardItems(1).subscribe((result) => {
      if (result) {
        this.noticeBoardItems = result;
      }
    });
  }

  getChangeArrowIcon(changeValue) {
    return (
      this.constants.assetsPath +
      '/img/icons/' +
      (parseInt(changeValue, 10) > 0 ? 'green-arrow-up.svg' : 'red-arrow-down.svg')
    );
  }
}
